<template>
    <label>
        <input
            :value="id"
            :checked="modelValue == id"
            :name="name"
            type="radio"
            class="item hidden"
            @change="$emit('update:modelValue', id)"
        />
        <div
            class="cursor-pointer space-y-2 rounded-sm border border-gray-400 bg-gray-600 p-3 whitespace-nowrap"
            :class="modelValue == id ? '!bg-blue-700' : ''"
        >
            <div class="text-center whitespace-nowrap text-white">{{ label }}</div>
        </div>
    </label>
</template>

<script>
export default {
    name: 'FeConfiguratorRadio',
    props: {
        name: { type: String, required: true },
        id: { type: [String, Number], required: true },
        modelValue: { type: [String, Number], default: null },
        label: { type: String, required: true },
    },
    emits: ['update:modelValue'],
};
</script>
